import Link from "next/link";

import Hero from "../components/hero";

import SeoMeta from "../components/seo-meta";
import { getSEOPageProps } from "../lib/seo";

import styles from "./policy.module.scss";
import config from "../config";

export default function TermsPage({ seo }) {
  return (
    <div className="container">
      <SeoMeta {...seo} />
      <Hero title="East Room Website Terms of Service" fullWidthTitle />

      <div className={styles.Policy}>
        <section>
          <p>
            <strong>Terms</strong>. East Room Holding Corp. (“we” or “us”) owns
            and operates the website at eastroom.com (the “Site”), where you can
            find information about our products and services. These Website
            Terms and Conditions (the “Website Terms”) describe the rights and
            obligations of an unregistered website user or visitor (“user” or
            “you”) in connection with your use of the Site. By accessing or
            using the Site in any way, including as an unregistered website
            visitor, you agree to be bound by these Website Terms and our
            Privacy Policy, which is available on the Site. These Website Terms
            apply only to your use of the Site, and the content made available
            on or through the Site, as an unregistered website user or visitor.
            If you use or access any of our physical space, restricted-access
            web-based services (i.e. those requiring a login), the broker or
            referral program or other services we provide, your use of such
            space, services or program is subject to the terms and conditions
            you received or accepted when you signed up for such space, services
            or program. From time to time, we may make modifications, deletions
            or additions to the Site or these Website Terms. Your continued use
            of the Site following the posting of any changes to the Website
            Terms constitutes acceptance of those changes.
          </p>

          <p>
            <strong>Eligibility</strong>. The Site and services it describes are
            available only to individuals who are at least 16 years old, unless
            we specify otherwise. No one under this age may access or use the
            Site or provide any personal information through the Site.
          </p>

          <p>
            <strong>Content</strong>. The text, images, videos, audio clips,
            software and other content generated, provided, or otherwise made
            accessible on or through the Site (collectively, “Content”) are
            contributed by us and our licensors. The Content and the Site are
            protected by Canadian and international copyright laws. We and our
            licensors retain all proprietary rights in the Site and the Content
            made available on or through the Site, and, except as expressly set
            forth in these Website Terms, no rights are granted to any Content.
            Subject to these Website Terms, we grant each user of the Site a
            worldwide, non-exclusive, non-sublicensable and non-transferable
            license to use (i.e., to download and display locally) Content
            solely for viewing, browsing and using the functionality of the
            Site. All Content is for general informational purposes only. We
            reserve the right, but do not have any obligation to monitor,
            remove, edit, modify or remove any Content, in our sole discretion,
            at any time for any reason or for no reason at all.
          </p>

          <p>
            <strong>Claims of Copyright Infringement</strong>. Claims of
            copyright infringement should be sent to East Room’s designated
            agent. Please visit East Rooms’s{" "}
            <Link href="/copyright" passHref>
              <a>Copyright Infringement</a>
            </Link>{" "}
            web page for the designated address and additional information.
          </p>

          <p>
            <strong>Recruitment Fraud</strong>. If you believe you have received
            a suspicious email concerning recruitment or solicitations, please
            visit East Room’s{" "}
            <Link href="/recruitment-fraud" passHref>
              <a>Recruitment Fraud</a>
            </Link>{" "}
            web page concerning identifying and reporting recruitment fraud.
          </p>

          <p>
            <strong>Disclaimer; Limitation of liability</strong>. To the extent
            permitted by law, we and our affiliates, parents, and successors and
            each of our and their employees, assignees, officers, agents and
            directors (collectively, the “East Room Parties”) disclaim all
            warranties and terms, express or implied, with respect to the Site,
            Content or services (including third party services) on or
            accessible through the Site, including any warranties or terms of
            merchantability, fitness for a particular purpose, title,
            non-infringement and any implied warranties, or arising from course
            of dealing, course of performance or usage in trade. In no event
            shall the East Room Parties be liable under contract, tort, strict
            liability, negligence or any other legal or equitable theory with
            respect to the Site for (a) any special, indirect, incidental,
            punitive, compensatory or consequential damages of any kind
            whatsoever (however arising) or (b) damages in excess of (in the
            aggregate) US$100.
          </p>

          <p>
            <strong>Miscellaneous</strong>. These Website Terms shall be
            governed by and construed in accordance with the laws of the
            Province of Ontario, excluding its conflicts of law rules, and
            Canada. These Website Terms constitute the entire agreement between
            us regarding the Site and supersedes and merges any prior proposals,
            understandings and contemporaneous communications. If any provision
            of these Website Terms is held to be invalid or unenforceable, that
            provision shall be limited or eliminated to the minimum extent
            necessary so that these Website Terms shall otherwise remain in full
            force and effect and enforceable. In order for any waiver of
            compliance with these Website Terms to be binding, we must provide
            you with written notice of such waiver. The failure of either party
            to enforce its rights under these Website Terms at any time for any
            period will not be construed as a waiver of such rights.
          </p>

          <p>
            <strong>Contact</strong>. If you have any questions, complaints, or
            claims with respect to the Site, you may contact us at Attn: Website
            Feedback, c/o East Room Holding Corp., 9 Davies, Toronto, ON, M4M
            1G3, Canada or info@eastroom.com.
          </p>
        </section>
      </div>
    </div>
  );
}

export async function getStaticProps() {
  return {
    props: {
      seo: await getSEOPageProps({ resolvedUrl: "/terms" })
    },
    revalidate: config.ISR_TIMING
  };
}
